import { Injectable } from '@angular/core';

import { PaymentMethod } from '@features/payment';

@Injectable()
export class PaymentMethodFilterService {
    public paymentConfigs: Record<string, Record<string, boolean>> = {
        RU: {
            filterCodWithGiftcard: true,
        },
        default: {
            filterCodWithGiftcard: false,
        },
    };

    public transform(items: any[], searchText: string, fieldName: string, include = true): any[] {
        if (!items) {
            return [];
        }

        if (!searchText) {
            return items;
        }

        const lowerCaseSearchText = searchText.toLowerCase();

        return items.filter((item) => {
            const fieldValue = item?.[fieldName];
            if (fieldValue) {
                const isMatch = fieldValue.toLowerCase().includes(lowerCaseSearchText);
                return include ? isMatch : !isMatch;
            }
            return false;
        });
    }

    public reorder(paymentMethods: PaymentMethod[], methodsOrderCodes: string[]): PaymentMethod[] {
        const orderedFilteredMethods = methodsOrderCodes.reduce((acc, currentMethodCode) => {
            acc.push(paymentMethods.find((method) => method.code === currentMethodCode));
            return acc.filter((method) => method !== undefined);
        }, []);

        const noOrderedFilteredMethods = paymentMethods.filter(el => !methodsOrderCodes.includes(el.code));
        return [ ...orderedFilteredMethods, ...noOrderedFilteredMethods ];
    }

    public hide(paymentMethods: PaymentMethod[], methodsHideCodes: string[]): PaymentMethod[] {
        return paymentMethods.filter((el) => {
            return !methodsHideCodes.includes(el.code);
        });
    }
}
